var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMadpakkehus = function SvgMadpakkehus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeMiterlimit: 10,
    d: "M13.521 13.415v-6.74l-5.518-5.5-5.524 5.5v6.74m2.036-.484h6.97M5.757 14.68l1.753-1.754m2.735 1.754-1.859-1.854m-.411 2.596v-2.764m.693-.283c.603-.493.785-.905.881-1.47.278-1.62-1.36-2.654-1.36-2.654s-.1 1.006-.7 1.356c-.388-.245-.656-.499-.656-.499s-.302.652-.378.982c-.226.982.177 1.615.8 2.127.665.542.756.872.756.872s.168-.373.657-.718z"
  })));
};
export default SvgMadpakkehus;